import { render } from "./vlabelmanageedit.vue?vue&type=template&id=eb6324f2&scoped=true"
import script from "./vlabelmanageedit.vue?vue&type=script&lang=js"
export * from "./vlabelmanageedit.vue?vue&type=script&lang=js"

import "./vlabelmanageedit.vue?vue&type=style&index=0&id=eb6324f2&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb6324f2"]])

export default __exports__